import { GalleryList } from '@/components/gallery';
import { type Attraction } from '@/config/objects/attractions';
import { useApiClient } from '@startupquickstart/frontend';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export function AttractionGalleryTab() {
  const { id } = useParams<{ id: string }>();
  const apiClient = useApiClient();

  const { data: attractionData } = useQuery<{ success: boolean; data: Attraction }>({
    queryKey: ['Attraction', id],
    queryFn: () => apiClient.get(`/attractions/${id}`),
    enabled: !!id,
  });

  const attraction = attractionData?.data;

  if (!id) return null;

  return (
    <GalleryList
      attractionId={id}
      featuredImageId={attraction?.featuredImageId}
      onFeaturedImageSwap={() => {
        // GalleryList already handles query invalidation
      }}
    />
  );
}
